"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Visible;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Visible(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "visible"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,77.31a46.9,46.9,0,0,1-42.238-26.2,2.5,2.5,0,0,1,0-2.226,47.149,47.149,0,0,1,84.476,0,2.5,2.5,0,0,1,0,2.226A46.9,46.9,0,0,1,50,77.31ZM12.812,50a42.149,42.149,0,0,0,74.376,0,42.149,42.149,0,0,0-74.376,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,67.38A17.38,17.38,0,1,1,67.38,50,17.4,17.4,0,0,1,50,67.38Zm0-29.76A12.38,12.38,0,1,0,62.38,50,12.394,12.394,0,0,0,50,37.62Z"
  })))));
}